
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.75 8.554a2.916 2.916 0 00-2.917-2.917h-3.75a.833.833 0 00-.833.833v8.334a.833.833 0 00.833.833h3.75a2.908 2.908 0 002.034-5 2.917 2.917 0 00.883-2.083zm-2.917 5.416H7.917v-2.5h2.916a1.25 1.25 0 110 2.5zm0-4.166H7.917v-2.5h2.916a1.25 1.25 0 110 2.5z","fill":"#000C1F"}})])
          )
        }
      }
    